import React, { useState, useEffect, useRef } from "react";
import { TiMessages } from "react-icons/ti";
import { IoIosCloseCircleOutline } from "react-icons/io";

const styles = {
  chatbotContainer: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "350px",
    zIndex: 1000,
  },
  chatbotButton: {
    backgroundColor: "#DFBD69",
    color: "white",
    padding: "15px",
    borderRadius: "50%",
    cursor: "pointer",
    border: "none",
    position: "absolute",
    bottom: "0",
    right: "0",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  chatbot: {
    fontFamily: "Arial, sans-serif",
    width: "100%",
    height: "500px",
    backgroundColor: "#ffffff",
    borderRadius: "15px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
    display: "none",
    flexDirection: "column",
    justifyContent: "space-between",
    background: "linear-gradient(135deg, #f0f4f8, #d9e2ec)",
    overflow: "hidden",
  },
  messageContainer: {
    overflowY: "auto",
    flex: 1,
    padding: "10px",
    maxHeight: "500px",
    minHeight: "100px",
  },
  messageBox: {
    marginBottom: "10px",
    fontSize: "1rem",
    padding: "10px",
    borderRadius: "10px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    color: "#333",
    maxWidth: "80%",
  },
   inputContainer: {
    display: "flex",
    alignItems: "center",
    padding: "0 16px 16px 16px", // Only left/right padding
    background: "none",
    gap: "10px",
    //marginBottom: "12px",
  },
  input: {
    flex: 1,
    border: "1px solid #ccc",
    padding: "0 12px",
    borderRadius: "5px",
    fontSize: "1rem",
    height: "40px",
    boxSizing: "border-box",
    background: "#fff",
  },
  button: {
    backgroundColor: "#DFBD69",
    color: "black",
    padding: "0 18px",
    borderRadius: "5px",
    cursor: "pointer",
    border: "none",
    height: "40px",
    fontSize: "1rem",
    minWidth: "64px",
    boxSizing: "border-box",
  },
  questionButton: {
    backgroundColor: "#28a745",
    color: "white",
    padding: "5px 10px", // Smaller padding
    borderRadius: "5px",
    cursor: "pointer",
    border: "none",
    margin: "3px", // Space between buttons
    fontSize: "0.9rem", // Smaller font
    display: "inline-block", // Makes them smaller instead of full width
  },
  // Add new styles for our custom chart
  chartContainer: {
    width: "80%", // Match the max-width of message boxes
    margin: "10px 0", // Align with message spacing
    padding: "15px",
    backgroundColor: "#e0e0e0", // Match message box color
    borderRadius: "10px", // Match message box radius
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)", // Match message box shadow
    border: "none", // Remove border
    alignSelf: "flex-start", // Align to the left like bot messages
  },

  chart: {
    width: "100%", // Full width of parent
    margin: "15px auto", // Center each chart
    backgroundColor: "#e5e5e5", // White background for each chart
    borderRadius: "8px",
    padding: "12px",
    boxShadow: "0 12px 3px rgba(0,0,0,0.03)",
    maxWidth: "100%", // Slightly less than 100% to create some padding
  },

  individualChart: {
    width: "80%", // Full width of parent
    margin: "10px 0", // Center each chart
    backgroundColor: "#e0e0e0", // White background for each chart
    borderRadius: "8px",
    padding: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    maxWidth: "90%", // Slightly less than 100% to create some padding
  },
  barContainer: {
    height: "26px",
    backgroundColor: "#f5f5f5",
    borderRadius: "5px",
    marginBottom: "3px",
    position: "relative",
    overflow: "hidden",
  },
  bar: {
    height: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    borderRadius: "5px",
    transition: "width 1s ease-in-out",
  },
  barValue: {
    position: "absolute",
    left: "50%", // Position in the middle horizontally
    top: "50%",
    transform: "translate(-50%, -50%)", // Center both horizontally and vertically
    fontWeight: "bold",
    fontSize: "0.9rem",
    color: "#333", // Ensure text is readable
    zIndex: 2, // Make sure it appears above the bar
  },
  scoreTitle: {
    textAlign: "center",
    fontWeight: "bold",
    margin: "0 0 10px 0",
    fontSize: "1rem",
  },
  strengthIndicator: {
    textAlign: "center",
    fontStyle: "italic",
    color: "#666",
    marginTop: "5px",
    fontSize: "0.9rem", // Increased font size for strength indicator
  },

  // Add a style for the help button that appears after category selection
  helpButton: {
    backgroundColor: "#28a745",
    color: "white",
    padding: "8px 15px",
    borderRadius: "5px",
    cursor: "pointer",
    border: "none",
    margin: "10px auto",
    fontSize: "0.9rem",
    display: "block",
    width: "fit-content",
  },
  restartButtonContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "0 10px 10px 10px",
    marginTop: "5px"
  },
  restartButtonBottom: {
    backgroundColor: '#dc3545',
    color: 'white',
    padding: '8px 15px',
    borderRadius: '5px',
    cursor: 'pointer',
    border: 'none',
    width: '100%',
    fontSize: '0.9rem'
  },

  // Add these new styles for the loading animation
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-start",
    backgroundColor: "#232224",
    color: "#DFBD69",
    padding: "10px 16px",
    borderRadius: "10px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    maxWidth: "80%",
    marginBottom: "10px",
  },
  loadingDots: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
  },
  dot: {
    width: "8px",
    height: "8px",
    backgroundColor: "#DFBD69",
    borderRadius: "50%",
    animation: "loading 1.4s infinite ease-in-out",
  },
  dot1: {
    animationDelay: "0s",
  },
  dot2: {
    animationDelay: "0.2s",
  },
  dot3: {
    animationDelay: "0.4s",
  },
};

// Add this CSS animation to your component (you can also add it to your global CSS)
const LoadingAnimation = () => {
  return (
    <>
      <style>
        {`
          @keyframes loading {
            0%, 80%, 100% {
              transform: scale(0.8);
              opacity: 0.5;
            }
            40% {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
      <div style={styles.loadingContainer}>
        <div style={styles.loadingDots}>
          <div style={{...styles.dot, ...styles.dot1}}></div>
          <div style={{...styles.dot, ...styles.dot2}}></div>
          <div style={{...styles.dot, ...styles.dot3}}></div>
        </div>
      </div>
    </>
  );
};

// Simple Bar Chart Component
const SimpleChart = ({ data, title }) => {
  const getBarColor = (category) => {
    const colors = {
      WEALTH: "#8884d8",
      HEALTH: "#82ca9d",
      CAREER: "#ffc658",
      RS: "#ff8042",
      WISDOM: "#0088fe",
    };
    return colors[category] || "#777";
  };

  // Function to determine strength based on value
  const getStrengthLabel = (value) => {
    if (value < 30) return "weak";
    if (value < 60) return "moderate";
    if (value < 85) return "strong";
    return "excellent";
  };

  return (
    <div style={styles.individualChart}>
      <h4 style={styles.scoreTitle}>{title}</h4>
      <div style={styles.barContainer}>
        <div
          style={{
            ...styles.bar,
            width: `${data.value}%`,
            backgroundColor: getBarColor(data.category),
          }}
        ></div>
        <span style={styles.barValue}>{data.value}/100</span>
      </div>
      <div style={styles.strengthIndicator}>{getStrengthLabel(data.value)}</div>
    </div>
  );
};

// Chart component specifically for use in the all charts display
const NatalChart = ({ data, title }) => {
  const getBarColor = (category) => {
    const colors = {
      WEALTH: "#8884d8",
      HEALTH: "#82ca9d",
      CAREER: "#ffc658",
      RS: "#ff8042",
      WISDOM: "#0088fe",
    };
    return colors[category] || "#777";
  };

  // Function to determine strength based on value
  const getStrengthLabel = (value) => {
    if (value < 30) return "weak";
    if (value < 60) return "moderate";
    if (value < 85) return "strong";
    return "excellent";
  };

  return (
    <div style={styles.chart}>
      <h4 style={styles.scoreTitle}>{title}</h4>
      <div style={styles.barContainer}>
        <div
          style={{
            ...styles.bar,
            width: `${data.value}%`,
            backgroundColor: getBarColor(data.category),
          }}
        ></div>
        <span style={styles.barValue}>{data.value}/100</span>
      </div>
      <div style={styles.strengthIndicator}>{getStrengthLabel(data.value)}</div>
    </div>
  );
};

const TipsChatbot = ({ selectedChart, chartData, period }) => {

  const hasGreeted = useRef(false);

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFinal, setIsFinal] = useState(false);
  const [hideInitialQuestions, setHideInitialQuestions] = useState(true); // Hide buttons on first API call
  const [isFirstSelection, setIsFirstSelection] = useState(true);
  // Add new states for analytics
  const [showChart, setShowChart] = useState(false);
  const [localChartData, setLocalChartData] = useState(null);
  const [chartTitle, setChartTitle] = useState("");
  // Add these state declarations here instead of inside fetchResponse
  const [showHelpButton, setShowHelpButton] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [hideCategoryButtons, setHideCategoryButtons] = useState(false);
  const [apiDate, setApiDate] = useState();
  const [allCharts, setAllCharts] = useState([]);
  const [showRestartButton, setShowRestartButton] = useState(false);
  const hasMounted = useRef(false);

  const [userDataSet, setUserData] = useState(null);

  const [Lwealth, setLWealth] = useState(10);
  const [Lcareer, setLCareer] = useState(10);
  const [Lrs, setLRs] = useState(10);
  const [Lhealth, setLHealth] = useState(10);
  const [Lwisdom, setLWisdom] = useState(10);
  //fortest
  // const [userGender, setUserGender] = useState("Male");
  const [userGender, setUserGender] = useState("");
  const [keywordMappings, setKeywordMappings] = useState({});
  const messagesEndRef = useRef(null);

  // Scroll to bottom when messages change
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  useEffect(() => {
    // Only greet if chartData and selectedChart are available
    if (chartData && selectedChart) {
      // Get the value for the selected chart
      const value = chartData[selectedChart] ?? 0;
      const displayName = {
        WEALTH: "Wealth",
        CAREER: "Career",
        HEALTH: "Health",
        RS: "Relationship",
        WISDOM: "Wisdom"
      }[selectedChart] || selectedChart;
    }
  }, [chartData, selectedChart]);
  
  useEffect(() => {
    if (chartData) {
      setUserChartValues({
        WEALTH: chartData.WEALTH ?? 0,
        CAREER: chartData.CAREER ?? 0,
        RS: chartData.RS ?? 0,
        HEALTH: chartData.HEALTH ?? 0,
        WISDOM: chartData.WISDOM ?? 0,
      });
    }
  }, [chartData, selectedChart]);

  const [userZodiac, setUserZodiac] = useState({
    sign: "",
    chineseSign: "",
    natal: ""
  });

  const [chartStrengthData, setChartStrengthData] = useState({
    rawValue: "",
    category: "" // "strong" or "weak"
  });

  const [lunarData, setLunarData] = useState({
    A1: null,
    A2: null,
    A3: null,
    A4: null,
    B1: null,
    B2: null,
    B3: null,
    B4: null
  });

  const [userChartValues, setUserChartValues] = useState({
    WEALTH: 0,
    CAREER: 0,
    RS: 0,
    HEALTH: 0,
    WISDOM: 0
  });

  const [activeCategory, setActiveCategory] = useState(null);

  useEffect(() => {
    if (selectedChart) {
      setActiveCategory(selectedChart.toUpperCase());
    }
  }, [selectedChart]);

  const fetchUserData = async () => {
    try {
      const userName = localStorage.getItem("username");
      const userID = localStorage.getItem("userID");

      const response = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            UserName: userName,
            ID: userID,
            UserToken: "",
            Token: {
              AccessToken:
                "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
            },
          }),
        }
      );

      const result = await response.json();
      console.log("API Response:", result);

      if (response.ok) {
        const userDOB = result.Profiles[0].DOB;
        if (userDOB && !isNaN(new Date(userDOB).getTime())) {
          setApiDate(userDOB);
          console.log("Valid DOB set as apiDate:", userDOB);
          
          // Fetch chart values after setting the date - this is the key addition
          await displayAllCharts(userDOB);
        } else {
          console.error("Invalid DOB received:", userDOB);
        }
        setUserGender(result.Profiles[0].Gender);
        
        return {
          ...result.Profiles[0],
          DOB: userDOB
        };
      } else {
        throw new Error(
          `Error: ${response.status} - ${result.message || "Request failed"}`
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  };

  const LunarConvert = async () => {
    console.log("Ensuring critical data is loaded...");
    
    try {
      // Parse the date from apiDate state
      const birthDate = new Date(apiDate);
      const year = birthDate.getFullYear();
      const month = (birthDate.getMonth() + 1);
      const day = birthDate.getDate();
      const hour = birthDate.getHours();
      const minutes = birthDate.getMinutes();

      // Format time as HH:MM
      const timeString = `${hour.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

      console.log(`Fetching critical data with: ${birthDate}`);
      console.log(`Parsed date: Year=${year}, Month=${month}, Day=${day}, Time=${timeString}`);

      // Combined API call to get both lunar data and chart strength
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/member/GetChineseDOB?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
      );
      
      const data = await response.json();
      console.log("Raw API response:", data);

      if (Array.isArray(data) && data.length > 0) {
        // Extract and set chart strength
        const chartStrength = data[0].CHART_STRENGHT;
        console.log("Chart Strength:", chartStrength);

        // Determine if strong or weak based on the string value
        const strengthCategory = chartStrength?.toLowerCase() === "strong" ? "strong" : "weak";
        
        // Update chart strength state
        setChartStrengthData({
          rawValue: chartStrength,
          category: strengthCategory
        });
        
        // Store lunar values
        const lunarValues = {
          A1: data[0]?.A1 || null,
          A2: data[0]?.A2 || null,
          A3: data[0]?.A3 || null,
          A4: data[0]?.A4 || null,
          B1: data[0]?.B1 || null,
          B2: data[0]?.B2 || null,
          B3: data[0]?.B3 || null,
          B4: data[0]?.B4 || null
        };

        // If A2 is missing, fetch it from the GetLunarHeavenlyStems API
        if (!lunarValues.A2) {
          const lunarResponse = await fetch(
            `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
          );
          
          const zodiacData = await lunarResponse.json();
          
          if (zodiacData && zodiacData.length > 0) {
            if (zodiacData[0].NATAL) {
              lunarValues.A2 = zodiacData[0].NATAL;
              console.log("Retrieved A2 value from GetLunarHeavenlyStems API:", lunarValues.A2);
            } else if (zodiacData[0].B1) {
              lunarValues.A2 = zodiacData[0].B1;
              console.log("Retrieved A2 value from B1 in GetLunarHeavenlyStems API:", lunarValues.A2);
            }
            
            // Also store zodiac sign information
            if (zodiacData[0].ZODIAC) {
              setUserZodiac(prev => ({
                ...prev,
                sign: zodiacData[0].ZODIAC,
                chineseSign: zodiacData[0].ZODIAC_CN || ""
              }));
            }
          }
        }
        
        // Update lunar data state
        setLunarData(lunarValues);
        
        // Also update userZodiac.natal
        if (lunarValues.A2) {
          setUserZodiac(prev => ({
            ...prev,
            natal: lunarValues.A2
          }));
          localStorage.setItem("userNatalElement", lunarValues.A2);
        }
        
        console.log("Critical data successfully loaded");
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error fetching critical data:", error);
      return false;
    }
  };

  // Add this function to ensure chart strength is fetched
  const ensureCriticalData = async () => {
    console.log("Ensuring critical data is loaded...");
    
    try {
      // Parse the date from apiDate state
      const birthDate = new Date(apiDate);
      const year = birthDate.getFullYear();
      const month = (birthDate.getMonth() + 1);
      const day = birthDate.getDate();
      const hour = birthDate.getHours();
      const minutes = birthDate.getMinutes();

      // Format time as HH:MM
      const timeString = `${hour.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

      console.log(`Fetching critical data with: ${birthDate}`);
      console.log(`Parsed date: Year=${year}, Month=${month}, Day=${day}, Time=${timeString}`);

      // Combined API call to get both lunar data and chart strength
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/member/GetChineseDOB?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
      );
      
      const data = await response.json();
      console.log("Raw API response:", data);

      if (Array.isArray(data) && data.length > 0) {
        // Extract and set chart strength explicitly
        const chartStrength = data[0].CHART_STRENGHT;
        console.log("Chart Strength from API:", chartStrength);

        // Determine if strong or weak based on the string value
        const strengthCategory = chartStrength?.toLowerCase() === "strong" ? "strong" : "weak";
        
        // Update chart strength state
        setChartStrengthData({
          rawValue: chartStrength,
          category: strengthCategory
        });
        
        // Store the chart strength in localStorage for persistence
        localStorage.setItem("userChartStrength", JSON.stringify({
          rawValue: chartStrength,
          category: strengthCategory
        }));
        
        // Also update lunar data from this API call
        const lunarValues = {
          A1: data[0]?.A1 || null,
          A2: data[0]?.A2 || null,
          A3: data[0]?.A3 || null,
          A4: data[0]?.A4 || null,
          B1: data[0]?.B1 || null,
          B2: data[0]?.B2 || null,
          B3: data[0]?.B3 || null,
          B4: data[0]?.B4 || null
        };
        
        // Update lunar data state
        setLunarData(lunarValues);

        localStorage.setItem("lunarData", JSON.stringify(lunarValues));
        
        // If A2 is missing, try the other API call
        if (!lunarValues.A2) {
          await LunarConvert();
        }
        
        return true;
      } else {
        console.error("Failed to fetch chart strength, API didn't return expected data");
        
        // Try loading from localStorage as fallback
        const savedChartStrength = localStorage.getItem("userChartStrength");
        if (savedChartStrength) {
          const parsedStrength = JSON.parse(savedChartStrength);
          console.log("Using saved chart strength from localStorage:", parsedStrength);
          setChartStrengthData(parsedStrength);
          return true;
        }
        
        // If all else fails, set a default value
        console.log("Setting default chart strength to 'strong'");
        setChartStrengthData({
          rawValue: "Strong",
          category: "strong"
        });
        return false;
      }
    } catch (error) {
      console.error("Error ensuring critical data:", error);
      
      // Set default values as a last resort
      setChartStrengthData({
        rawValue: "Strong",
        category: "strong"
      });
      return false;
    }
  };

  const checkUserLogin = () => {
    const userName = localStorage.getItem("username");
    const userID = localStorage.getItem("userID");

  };
  
  const fetchKeywordMappings = async () => {
    try {
      const response = await fetch("https://xianhefairy.com/LotusFairy_API/api/Booking/getKey");
      const data = await response.json();
      
      // Convert the array into a more usable object structure
      const mappings = {};
      data.forEach(item => {
        // Split multiple keywords and trim them
        const keywords = item.KeywordText.split(',').map(k => k.trim().toLowerCase());
        
        // Map each keyword to its question ID
        keywords.forEach(keyword => {
          mappings[keyword] = item.QuestionID;
        });
      });
      
      console.log("Keyword mappings loaded:", mappings);
      setKeywordMappings(mappings);
    } catch (error) {
      console.error("Error fetching keyword mappings:", error);
    }
  };

  const categoryMap = {
    wealth: { apiKey: "WEALTH_TOTAL", displayName: "Wealth Score" },
    health: { apiKey: "HEALTH_TOTAL", displayName: "Health Score" },
    career: { apiKey: "CAREER_TOTAL", displayName: "Career Score" },
    relationship: { apiKey: "RS_TOTAL", displayName: "Relationship Score" },
    wisdom: { apiKey: "WISDOM_TOTAL", displayName: "Wisdom Score" },
  };

  const displayAllCharts = async (dob) => {
    let natalData = null;
    try {
      // Parse the date from apiDate state
      const birthDate = new Date(apiDate || dob);
      const year = birthDate.getFullYear();
      const month = birthDate.getMonth() + 1;
      const day = birthDate.getDate();
      const hour = birthDate.getHours();
      const minutes = birthDate.getMinutes();

      // Format time as HH:MM
      const timeString = `${hour.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;

      // Call API directly instead of using fetchUserData
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
      );

      const data = await response.json();
      console.log("All charts API response:", data);

      // Check for Tables array 
      if (data && data.Tables && data.Tables.length > 0) {
        // Use only the first table
        const firstTable = data.Tables[0];

        if (firstTable && firstTable.length > 0) {
          natalData = firstTable[0]; // First row of first table
        }
      } else if (data && data.length > 0) {
        // Fallback to old format
        natalData = data[0];
      }
    } catch (error) {
      console.log("Error fetching natal data for charts:", error);
    }

    
    if (natalData) {
      const categories = Object.keys(categoryMap);

      // Create chart data for all categories
      const charts = categories.map((category) => {
        const mapping = categoryMap[category];
        const value = natalData[mapping.apiKey] || 0;

        return {
          category: mapping.apiKey,
          label: mapping.displayName.split(" ")[0],
          value: value,
          title: mapping.displayName,
        };
      });

      setAllCharts(charts);
      console.log("Charts created successfully:", charts);

      const chartValues = {
        WEALTH: natalData.WEALTH_TOTAL || 0,
        CAREER: natalData.CAREER_TOTAL || 0,
        RS: natalData.RS_TOTAL || 0,
        HEALTH: natalData.HEALTH_TOTAL || 0,
        WISDOM: natalData.WISDOM_TOTAL || 0
      };

      console.log("Setting userChartValues from displayAllCharts:", chartValues);
      setUserChartValues(chartValues);
    } else {
      console.log("No natal data available to create charts");

      setUserChartValues({
        WEALTH: 0,
        CAREER: 0,
        RS: 0,
        HEALTH: 0,
        WISDOM: 0
      });
    }

    
  };

  
  useEffect(() => {
    checkUserLogin();
    //setIsLoggedIn(true);
    // Add this line to fetch keyword mappings
    fetchKeywordMappings();

    const savedChartStrength = localStorage.getItem("userChartStrength");
    if (savedChartStrength) {
      try {
        const parsedStrength = JSON.parse(savedChartStrength);
        console.log("Found saved chart strength in localStorage:", parsedStrength);
        setChartStrengthData(parsedStrength);
      } catch (e) {
        console.error("Error parsing saved chart strength:", e);
      }
    }

    // Load saved natal element from localStorage
    const savedNatal = localStorage.getItem("userNatalElement");
    const savedLunarData = localStorage.getItem("lunarData");
    if (savedLunarData) {
      try {
        const parsedLunarData = JSON.parse(savedLunarData);
        console.log("Found saved lunar data in localStorage:", parsedLunarData);
        setLunarData(parsedLunarData);
        
        // Add console log to show A1-B4 data status
        console.log("A1-B4 Data Status:");
        console.log("A1:", parsedLunarData.A1 || "Not stored");
        console.log("A2:", parsedLunarData.A2 || "Not stored");
        console.log("A3:", parsedLunarData.A3 || "Not stored");
        console.log("A4:", parsedLunarData.A4 || "Not stored");
        console.log("B1:", parsedLunarData.B1 || "Not stored");
        console.log("B2:", parsedLunarData.B2 || "Not stored");
        console.log("B3:", parsedLunarData.B3 || "Not stored");
        console.log("B4:", parsedLunarData.B4 || "Not stored");
        
        // Check if all A1-B4 values are stored
        const allValues = [
          parsedLunarData.A1, parsedLunarData.A2, parsedLunarData.A3, parsedLunarData.A4,
          parsedLunarData.B1, parsedLunarData.B2, parsedLunarData.B3, parsedLunarData.B4
        ];
        const storedCount = allValues.filter(val => val !== null && val !== undefined).length;
        console.log(`A1-B4 Storage Summary: ${storedCount}/8 values stored`);
        
      } catch (e) {
        console.error("Error parsing saved lunar data:", e);
      }
    } else {
      console.log("No A1-B4 data found in localStorage");
    }
    
    if (savedNatal) {
      console.log("Found saved natal element in localStorage:", savedNatal);
      
      // Update userZodiac
      setUserZodiac(prev => ({
        ...prev,
        natal: savedNatal
      }));
      
      // Also update lunarData
      setLunarData(prev => ({
        ...prev,
        A2: savedNatal
      }));
    }
    console.log("State changed - currentCategory:", currentCategory);
    console.log("State changed - showHelpButton:", showHelpButton);

    // Create an async function that runs all fetches in sequence
    const fetchAllUserData = async () => {
      try {
        const userData = await fetchUserData();
        const criticalDataResult = await ensureCriticalData();
        setTimeout(() => {
          displayAllCharts();
        }, 500);
      } catch (error) {
        console.error("Error fetching initial user data:", error);
      }
    };
    
    fetchAllUserData();

    
    // Run initial API call only once after data is loaded
    if (!hasMounted.current && apiDate) {
      hasMounted.current = true;
      setIsFinal(false);
      setHideInitialQuestions(true);
      setHideCategoryButtons(true);
      setQuestions([]);
      setIsFirstSelection(true);
      setShowHelpButton(false);
    }
  }, [apiDate]);

  useEffect(() => {
    const hasChartValues = Object.values(userChartValues).some(val => val !== 0);
    if (!hasGreeted.current && hasChartValues && selectedChart) {
      hasGreeted.current = true;
      fetchResponse("-1", null, selectedChart.toLowerCase());
    }

  }, [userChartValues, selectedChart]);

  // If user is not logged in, don't render the chatbot at all

  const handleRestart = () => {
    // Save the current identity data
    const currentGender = userGender;
    const currentNatal = lunarData?.A2;
    const currentChartStrength = chartStrengthData?.category;

    setMessages([]);
    setQuestions([]);
    setIsFinal(false);
    setHideInitialQuestions(true);
    setShowChart(false);
    setShowHelpButton(false);
    setHideCategoryButtons(true);
    setCurrentCategory(null);
    setLocalChartData(null);
    setShowRestartButton(false);
    setAllCharts([]);

    // Pass null as the questionId parameter to reset it
    fetchResponse("-1", null, selectedChart ? selectedChart.toLowerCase() : undefined);

    // Make sure we immediately have the data available
    setTimeout(() => {
      // Only fetch charts but preserve identity data
      displayAllCharts();
      
      // Make sure the identity data persists
      console.log("Preserving identity data after restart");
      console.log("Gender:", currentGender);
      console.log("Natal Element:", currentNatal);
      console.log("Chart Strength:", currentChartStrength);
      
      // Double check that identity data wasn't inadvertently reset
      if (!userGender || !lunarData?.A2 || !chartStrengthData?.category) {
        // Restore values if they got reset
        setUserGender(currentGender);
        setLunarData(prev => ({
          ...prev,
          A2: currentNatal // Restore natal element
        }));
        setChartStrengthData(currentChartStrength);
      }
    }, 500);
  };

  const fetchResponse = async (userQuery, questionId = null, categoryOverride = null) => {
    console.log("CRITICAL DATA CHECK:");
    console.log("Gender:", userGender); // Should be "Male" or "Female"
    console.log("Chart Strength:", chartStrengthData); // Should contain {category: "strong" or "weak"}
    console.log("Current natal element value:", userZodiac.natal);
    console.log("Current lunarData.A2 value:", lunarData.A2);
    console.log("User's Zodiac Sign:", userZodiac.sign);
    console.log("Natal Element:", lunarData?.A2); // Should be the natal element
    setHideInitialQuestions(true);
    setLoading(true);

    // Add minimum delay of 1 second for loading animation
    await new Promise(resolve => setTimeout(resolve, 1000));

    // if (activeCategory) {
    //   try {
    //     // Fetch the keyword mappings to get all categories dynamically
    //     const mappingsResponse = await fetch("https://xianhefairy.com/LotusFairy_API/api/Booking/getKey");
    //     const mappingsData = await mappingsResponse.json();
        
    //     console.log("Raw mappings data:", mappingsData);
        
    //     // Build keyword-to-category mapping by analyzing the keywords themselves
    //     const keywordToCategoryMap = {};
        
    //     mappingsData.forEach(mapping => {
    //       if (mapping.KeywordText) {
    //         const keywords = mapping.KeywordText.split(',').map(k => k.trim().toLowerCase());
            
    //         // Determine category from the keywords
    //         let categoryForThisMapping = null;
            
    //         // Check if any keyword indicates a specific category
    //         for (const keyword of keywords) {
    //           if (keyword === 'rs' || keyword === 'relationship') {
    //             categoryForThisMapping = 'RS';
    //             break;
    //           } else if (keyword === 'wealth') {
    //             categoryForThisMapping = 'WEALTH';
    //             break;
    //           } else if (keyword === 'career') {
    //             categoryForThisMapping = 'CAREER';
    //             break;
    //           } else if (keyword === 'health') {
    //             categoryForThisMapping = 'HEALTH';
    //             break;
    //           } else if (keyword === 'wisdom') {
    //             categoryForThisMapping = 'WISDOM';
    //             break;
    //           }
    //         }
            
    //         // If we found a category indicator, assign ALL keywords in this mapping to that category
    //         if (categoryForThisMapping) {
    //           keywords.forEach(keyword => {
    //             keywordToCategoryMap[keyword] = categoryForThisMapping;
    //           });
    //         }
            
    //         // If no explicit category found, try to use apiKey if available
    //         else if (mapping.apiKey) {
    //           keywords.forEach(keyword => {
    //             keywordToCategoryMap[keyword] = mapping.apiKey;
    //           });
    //         }
    //       }
    //     });
        
    //     console.log("Dynamic keyword-to-category mapping:", keywordToCategoryMap);
        
    //     // Check if user's query contains keywords from other categories
    //     // const userQueryLower = userQuery.toLowerCase();
    //     // let blockedCategory = null;
        
    //     // Object.keys(keywordToCategoryMap).forEach(keyword => {
    //     //   const keywordCategory = keywordToCategoryMap[keyword];
          
    //     //   // If keyword belongs to different category and appears in query
    //     //   if (keywordCategory !== activeCategory && userQueryLower.includes(keyword)) {
    //     //     blockedCategory = keywordCategory;
    //     //     console.log(`Found cross-category keyword: "${keyword}" belongs to ${keywordCategory}, but active category is ${activeCategory}`);
    //     //   }
    //     // });
        
    //     // if (blockedCategory) {
    //     //   const getDisplayName = (categoryKey) => {
    //     //     const displayNames = {
    //     //       'WEALTH': 'Wealth',
    //     //       'CAREER': 'Career', 
    //     //       'HEALTH': 'Health',
    //     //       'RS': 'Relationship',
    //     //       'WISDOM': 'Wisdom'
    //     //     };
    //     //     return displayNames[categoryKey] || categoryKey;
    //     //   };
          
    //     //   const activeDisplayName = getDisplayName(activeCategory);
    //     //   const blockedDisplayName = getDisplayName(blockedCategory);
          
    //     //   setMessages(prev => [
    //     //     ...prev,
    //     //     { sender: "user", text: userQuery },
    //     //     { 
    //     //       sender: "bot", 
    //     //       text: `This chat is currently focused on ${activeDisplayName}. Your question about ${blockedDisplayName} cannot be answered here. Please ask questions related to ${activeDisplayName}.`
    //     //     }
    //     //   ]);
          
    //     //   setLoading(false);
    //     //   setInput("");
    //     //   return;
    //     // }
        
    //   } catch (error) {
    //     console.error("Error fetching dynamic category data:", error);
    //     // If API fails, don't block anything
    //   }
    // }

    if (userQuery !== "-1" && 
      !userQuery.toLowerCase().includes("natal") && 
      !Object.keys(categoryMap).includes(userQuery.toLowerCase())) {
      setAllCharts([]);
    }
  
    // Normalize the query for matching
    const normalizedQuery = userQuery.toLowerCase();

    // First check for exact match in keyword mappings (if no questionId is provided)
    if (!questionId) {
      let matchedQuestionId = null;
      console.log("Current natal element value:", userZodiac.natal);
      console.log("Current natal element value:", userZodiac.natal);
      console.log("Current lunarData.A2 value:", lunarData.A2);

      try {
        // Fetch the keyword mappings to check for matches
        const mappingsResponse = await fetch("https://xianhefairy.com/LotusFairy_API/api/Booking/getKey");
        const mappingsData = await mappingsResponse.json();
        
        console.log("Checking for keyword matches with dynamic validation...");
        
        // Get user's current A1-B4 values
        const userA1 = lunarData?.A1;
        const userA2 = lunarData?.A2;
        const userA3 = lunarData?.A3;
        const userA4 = lunarData?.A4;
        const userB1 = lunarData?.B1;
        const userB2 = lunarData?.B2;
        const userB3 = lunarData?.B3;
        const userB4 = lunarData?.B4;
        
        console.log("User's A1-B4 values:");
        console.log("A1:", userA1, "A2:", userA2, "A3:", userA3, "A4:", userA4);
        console.log("B1:", userB1, "B2:", userB2, "B3:", userB3, "B4:", userB4);
        
        // STEP 1: Find all mappings that match the user's query keywords
        let potentialMatches = [];
        
        for (const mapping of mappingsData) {
          const chartKeyword = selectedChart.toLowerCase() === "rs" ? "relationship" : selectedChart.toLowerCase();
          const mappingTextLower = mapping.KeywordText ? mapping.KeywordText.toLowerCase() : "";
          const mappingQuestionLower = mapping.QuestionText ? mapping.QuestionText.toLowerCase() : "";
          const combinedMappingText = mappingTextLower + " " + mappingQuestionLower;

          if (period) {
            const periodLower = period.toLowerCase();
            const otherPeriods = ['daily', 'monthly', 'yearly', 'natal'].filter(p => p !== periodLower);
            // Must match the category
            if (!mappingTextLower.includes(chartKeyword) && !mappingQuestionLower.includes(chartKeyword)) {
              continue;
            }
            if (periodLower === 'natal') {
              // For NATAL: skip if any non-natal period appears in either KeywordText or QuestionText
              if (otherPeriods.some(p => combinedMappingText.includes(p))) {
                continue;
              }
            } else {
              // For daily/monthly/yearly: skip if a DIFFERENT period is explicitly mentioned in either field
              if (otherPeriods.some(p => combinedMappingText.includes(p))) {
                continue;
              }
            }
          }

          // const chartKeyword = selectedChart.toLowerCase() === "rs" ? "relationship" : selectedChart.toLowerCase();
          // const mappingTextLower = mapping.KeywordText ? mapping.KeywordText.toLowerCase() : "";

          // if (period) {
          //   const periodLower = period.toLowerCase();
          //   if (periodLower === 'natal') {
          //     // For NATAL, keyword must contain the category and not other periods.
          //     const otherPeriods = ['daily', 'monthly', 'yearly'];
          //     if (!mappingTextLower.includes(chartKeyword) || otherPeriods.some(p => mappingTextLower.includes(p))) {
          //       continue;
          //     }
          //   } else {
          //     // For other periods, keyword must contain the period AND category.
          //     // if (!mappingTextLower.includes(periodLower) || !mappingTextLower.includes(chartKeyword)) {
          //     //   continue;
          //     // }
          //     // For other periods: skip only if the mapping explicitly mentions a DIFFERENT period.
          //     const otherPeriods = ['daily', 'monthly', 'yearly', 'natal'].filter(p => p !== periodLower);
          //     if (!mappingTextLower.includes(chartKeyword) || otherPeriods.some(p => mappingTextLower.includes(p))) {
          //       continue;
          //     }
          //   }
          // }
          if (mapping.KeywordText) {
            // Split keywords and check if any match the user query
            const keywords = mapping.KeywordText.split(',').map(k => k.trim().toLowerCase());
            const userQueryLower = userQuery.toLowerCase().trim();
            
            // Enhanced keyword matching with multiple strategies
            let keywordMatch = false;
            
            // 1. Basic keyword matching (original logic)
            keywordMatch = keywords.some(keyword => 
              userQueryLower.includes(keyword) || keyword.includes(userQueryLower)
            );
            
            // 2. If still no match, try partial matching with individual query words
            if (!keywordMatch) {
              const queryWords = userQueryLower.split(/\s+/).filter(word => word.length > 2);
              
              for (const keyword of keywords) {
                const keywordWords = keyword.split(/\s+/).filter(word => word.length > 2);
                let wordMatchCount = 0;
                
                for (const queryWord of queryWords) {
                  if (keywordWords.some(kw => kw.includes(queryWord) || queryWord.includes(kw))) {
                    wordMatchCount++;
                  }
                }
                
                // If significant word overlap exists
                if (queryWords.length > 0 && wordMatchCount / queryWords.length >= 0.6) {
                  console.log(`Partial word match: "${keyword}" matches query "${userQueryLower}"`);
                  keywordMatch = true;
                  break;
                }
              }
            }
            
            // 3. Zodiac-specific matching logic (if no basic match found)
            if (!keywordMatch && userZodiac && userZodiac.sign && mapping.Natal) {
              const userZodiacSign = userZodiac.sign.toLowerCase();
              const mappingZodiac = mapping.Natal.toLowerCase();
              
              console.log(`Checking zodiac context - User: "${userZodiacSign}" vs Mapping: "${mappingZodiac}"`);
              
              // Only proceed if the mapping is for the user's zodiac sign
              if (userZodiacSign === mappingZodiac) {
                console.log(`Zodiac match found! Checking if query relates to keywords...`);
                
                // Check if the query contains keywords that would make sense for this zodiac-specific mapping
                for (const keyword of keywords) {
                  // Check if significant portions of the keyword appear in the query
                  const keywordParts = keyword.split(/\s+/).filter(part => part.length > 2);
                  let matchCount = 0;
                  
                  for (const part of keywordParts) {
                    if (userQueryLower.includes(part)) {
                      matchCount++;
                    }
                  }
                  
                  // If majority of the keyword parts are in the query
                  if (keywordParts.length > 0 && matchCount / keywordParts.length >= 0.5) {
                    console.log(`Zodiac context match: User query "${userQuery}" matches keyword "${keyword}" for ${mappingZodiac}`);
                    keywordMatch = true;
                    break;
                  }
                  
                  // Also check for partial matches in reverse (query parts in keyword)
                  const queryParts = userQueryLower.split(/\s+/).filter(part => part.length > 2);
                  let reverseMatchCount = 0;
                  
                  for (const queryPart of queryParts) {
                    if (keyword.includes(queryPart)) {
                      reverseMatchCount++;
                    }
                  }
                  
                  if (queryParts.length > 0 && reverseMatchCount / queryParts.length >= 0.5) {
                    console.log(`Zodiac context reverse match: Query "${userQuery}" parts found in keyword "${keyword}" for ${mappingZodiac}`);
                    keywordMatch = true;
                    break;
                  }
                }
              }
            }
            
            // If we found a keyword match, add to potential matches
            if (keywordMatch) {
              potentialMatches.push(mapping);
              console.log(`Added potential match: ID ${mapping.QuestionID}, Keywords: ${mapping.KeywordText}`);
            }
          }
        }
        
        console.log(`Found ${potentialMatches.length} potential matches`);
        
        // STEP 2: If we have potential matches, find the most specific one
        if (potentialMatches.length > 0) {
          let bestMatch = null;
          let bestSpecificityScore = -1;
          
          for (const mapping of potentialMatches) {
            console.log(`\nEvaluating match: ID ${mapping.QuestionID}`);
            console.log(`Mapping - Gender: ${mapping.Gender}, Strength: ${mapping.Strength}, Natal: ${mapping.Natal}, Symbol: ${mapping.Symbol}`);
            
            let specificityScore = 0;
            let isValidMatch = true;
            
            // Check if this mapping requires A1-B4 natal element validation
            let requiresNatalElementValidation = false;
            let natalRequirements = [];
            
            if (mapping.Natal && mapping.Natal.trim() !== "") {
              // Parse the Natal field to see if it contains A1-B4 references
              natalRequirements = mapping.Natal.split(',').map(n => n.trim());
              
              // Check if any of the requirements are A1-B4 values
              const a1b4Fields = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'];
              requiresNatalElementValidation = natalRequirements.some(req => a1b4Fields.includes(req));
              
              console.log(`Natal requirements: ${natalRequirements.join(', ')}`);
              console.log(`Requires A1-B4 validation: ${requiresNatalElementValidation}`);
            }
            
            // GENDER VALIDATION
            if (mapping.Gender !== -1) {
              const userGenderCode = userGender?.toLowerCase() === "male" ? 0 : 1;
              if (mapping.Gender === userGenderCode) {
                specificityScore += 10; // High score for gender match
                console.log(`✅ Gender match: User ${userGender} (${userGenderCode}) = Mapping ${mapping.Gender}`);
              } else {
                console.log(`❌ Gender mismatch: User ${userGender} (${userGenderCode}) ≠ Mapping ${mapping.Gender}`);
                isValidMatch = false;
              }
            } else {
              console.log(`⚪ Gender: Not specified in mapping (accepts any)`);
            }

              if (!isValidMatch) {
                console.log(`⏭️ Skipping remaining validation for ID ${mapping.QuestionID} - already invalid`);
                continue;
              }
            
            // STRENGTH VALIDATION
            if (mapping.Strength !== -1) {
              const userStrengthCode = chartStrengthData?.category === "strong" ? 0 : 1;
              if (mapping.Strength === userStrengthCode) {
                specificityScore += 10; // High score for strength match
                console.log(`✅ Strength match: User ${chartStrengthData?.category} (${userStrengthCode}) = Mapping ${mapping.Strength}`);
              } else {
                console.log(`❌ Strength mismatch: User ${chartStrengthData?.category} (${userStrengthCode}) ≠ Mapping ${mapping.Strength}`);
                isValidMatch = false;
              }
            } else {
              console.log(`⚪ Strength: Not specified in mapping (accepts any)`);
            }
            
              if (!isValidMatch) {
              console.log(`⏭️ Skipping remaining validation for ID ${mapping.QuestionID} - already invalid`);
              continue;
            }
            // NATAL/SYMBOL VALIDATION
            if (requiresNatalElementValidation) {
              console.log("🔍 A1-B4 natal element validation required");
              
              if (mapping.Symbol && mapping.Symbol.trim() !== "") {
                // Parse the symbol to get the values to match
                // Handle both single values and comma-separated values
                const symbolParts = mapping.Symbol.includes(',') 
                  ? mapping.Symbol.split(',').map(s => s.trim())
                  : mapping.Symbol.split('.').map(s => s.trim());
                
                console.log("Symbol parts:", symbolParts);
                console.log("Natal requirements:", natalRequirements);
                
                // Check if we have the required natal values based on the Natal field
                let allRequiredValuesMatch = true;
                
                // Handle the case where we have multiple symbols for the same natal requirement
                if (symbolParts.length > natalRequirements.length) {
                  console.log("Multiple symbols found for natal requirements");
                  
                  // For each natal requirement, check if any of the symbols match
                  for (let i = 0; i < natalRequirements.length; i++) {
                    const requirement = natalRequirements[i];
                    let userValue = null;
                    
                    // Get the user's value based on the requirement
                    switch (requirement) {
                      case 'A1': userValue = lunarData?.A1; break;
                      case 'A2': userValue = lunarData?.A2; break;
                      case 'A3': userValue = lunarData?.A3; break;
                      case 'A4': userValue = lunarData?.A4; break;
                      case 'B1': userValue = lunarData?.B1; break;
                      case 'B2': userValue = lunarData?.B2; break;
                      case 'B3': userValue = lunarData?.B3; break;
                      case 'B4': userValue = lunarData?.B4; break;
                      default:
                        console.log(`❌ Unknown A1-B4 requirement: ${requirement}`);
                        allRequiredValuesMatch = false;
                        continue;
                    }
                    
                    const cleanUserValue = userValue ? userValue.toString().trim().replace(/\s+/g, '') : '';
                    
                    // Check if the user value matches ANY of the symbols
                    let requirementMatched = false;
                    
                    for (const symbolValue of symbolParts) {
                      const cleanUserValue = userValue ? userValue.toString().trim().replace(/\s+/g, '') : '';
                      const cleanSymbolValue = symbolValue ? symbolValue.toString().trim().replace(/\s+/g, '') : '';
                      
                      // Enhanced matching logic - now ignores all spaces
                      let valueMatch = false;
                      
                      if (cleanUserValue && cleanSymbolValue) {
                        // Remove all spaces from both values for comparison
                        const spacefreUserValue = cleanUserValue.replace(/\s/g, '');
                        const spacefreSymbolValue = cleanSymbolValue.replace(/\s/g, '');
                        
                        // Try multiple matching strategies with space-free values
                        valueMatch = spacefreUserValue === spacefreSymbolValue ||
                                    spacefreUserValue.includes(spacefreSymbolValue) ||
                                    spacefreSymbolValue.includes(spacefreUserValue) ||
                                    spacefreUserValue.toLowerCase() === spacefreSymbolValue.toLowerCase();
                      }
                      
                      console.log(`${requirement}: User="${cleanUserValue}" vs Symbol="${cleanSymbolValue}" = ${valueMatch ? '✅' : '❌'}`);
                      
                      if (valueMatch) {
                        console.log(`✅ ${requirement}: User="${cleanUserValue}" matches Symbol="${cleanSymbolValue}"`);
                        requirementMatched = true;
                        specificityScore += 5; // Medium score for each natal element match
                        break; // Found a match, no need to check other symbols
                      }
                    }
                    
                    if (!requirementMatched) {
                      console.log(`❌ ${requirement}: User="${cleanUserValue}" doesn't match any symbols: ${symbolParts.join(', ')}`);
                      allRequiredValuesMatch = false;
                    }
                  }
                } else {
                  // Original logic for 1:1 mapping between natal requirements and symbols
                  for (let i = 0; i < natalRequirements.length; i++) {
                    const requirement = natalRequirements[i];
                    const symbolValue = symbolParts[i];
                    
                    let userValue = null;
                    
                    // Get the user's value based on the requirement
                    switch (requirement) {
                      case 'A1': userValue = lunarData?.A1; break;
                      case 'A2': userValue = lunarData?.A2; break;
                      case 'A3': userValue = lunarData?.A3; break;
                      case 'A4': userValue = lunarData?.A4; break;
                      case 'B1': userValue = lunarData?.B1; break;
                      case 'B2': userValue = lunarData?.B2; break;
                      case 'B3': userValue = lunarData?.B3; break;
                      case 'B4': userValue = lunarData?.B4; break;
                      default:
                        console.log(`❌ Unknown A1-B4 requirement: ${requirement}`);
                        allRequiredValuesMatch = false;
                        continue;
                    }
                    
                    // Clean and normalize both values for comparison
                    const cleanUserValue = userValue ? userValue.toString().trim().replace(/\s+/g, '') : '';
                    const cleanSymbolValue = symbolValue ? symbolValue.toString().trim().replace(/\s+/g, '') : '';
                    
                    // Enhanced matching logic
                    let valueMatch = false;
                    
                    if (cleanUserValue && cleanSymbolValue) {
                      // Try multiple matching strategies
                      valueMatch = cleanUserValue === cleanSymbolValue ||
                                  cleanUserValue.includes(cleanSymbolValue) ||
                                  cleanSymbolValue.includes(cleanUserValue) ||
                                  cleanUserValue.toLowerCase() === cleanSymbolValue.toLowerCase();
                    }
                    
                    console.log(`${requirement}: User="${cleanUserValue}" vs Symbol="${cleanSymbolValue}" = ${valueMatch ? '✅' : '❌'}`);
                    
                    if (valueMatch) {
                      specificityScore += 5; // Medium score for each natal element match
                    } else {
                      allRequiredValuesMatch = false;
                    }
                  }
                }
                
                if (!allRequiredValuesMatch) {
                  console.log("❌ A1-B4 symbol/natal element validation failed");
                  isValidMatch = false;
                } else {
                  console.log("✅ All A1-B4 symbol/natal elements match");
                }
              } else {
                console.log("⚪ A1-B4 validation required but no symbol provided in mapping");
              }
            } else {
              // Not A1-B4 validation, check for zodiac sign matching
              if (mapping.Natal && userZodiac && userZodiac.sign) {
                const mappingNatal = mapping.Natal.toLowerCase();
                const userZodiacLower = userZodiac.sign.toLowerCase();
                
                if (mappingNatal === userZodiacLower) {
                  specificityScore += 5; // Medium score for zodiac match
                  console.log(`✅ Zodiac match: User "${userZodiacLower}" = Mapping "${mappingNatal}"`);
                } else {
                  console.log(`❌ Zodiac mismatch: User "${userZodiacLower}" ≠ Mapping "${mappingNatal}"`);
                  isValidMatch = false;
                }
              } else {
                console.log(`⚪ Zodiac: Not specified or not available`);
              }
            }

              if (!isValidMatch) {
              console.log(`⏭️ Skipping remaining validation for ID ${mapping.QuestionID} - already invalid`);
              continue;
            }

            if (mapping.PercentBracket && mapping.PercentBracket.trim() !== "") {
              console.log("🔍 PercentBracket validation required");
              
              // Parse the PercentBracket - format: "min, max" or single value
              const bracketParts = mapping.PercentBracket.split(',').map(s => s.trim());
              let minPercent = 0;
              let maxPercent = 100;
              
              if (bracketParts.length === 2) {
                minPercent = parseFloat(bracketParts[0]) || 0;
                maxPercent = parseFloat(bracketParts[1]) || 100;
              } else if (bracketParts.length === 1) {
                const singleValue = parseFloat(bracketParts[0]) || 0;
                minPercent = singleValue;
                maxPercent = singleValue;
              }
              
              console.log(`PercentBracket range: ${minPercent} - ${maxPercent}`);
              
              // Check if we need to validate against specific chart categories
              let categoryToCheck = null;
              
              if (mapping.KeywordText) {
                const keywords = mapping.KeywordText.toLowerCase();
                if (keywords.includes('wealth')) {
                  categoryToCheck = 'WEALTH';
                } else if (keywords.includes('career')) {
                  categoryToCheck = 'CAREER';
                } else if (keywords.includes('health')) {
                  categoryToCheck = 'HEALTH';
                } else if (keywords.includes('rs')) {
                  categoryToCheck = 'RS';
                } else if (keywords.includes('wisdom')) {
                  categoryToCheck = 'WISDOM';
                }
              }

              if (!categoryToCheck && mapping.apiKey) {
                categoryToCheck = mapping.apiKey;
              }
              
              // Validate against the appropriate category
              const rawKey = selectedChart ? selectedChart.toUpperCase() : categoryToCheck;
              const chartKey = rawKey === 'RELATIONSHIP' ? 'RS' : rawKey;
              const chartValueRaw = chartData && chartKey && chartData[chartKey] !== undefined
                ? parseFloat(chartData[chartKey])
                : userChartValues[chartKey];

              // Use Math.ceil for bracket comparison
              const chartValue = Math.ceil(chartValueRaw);

              if (chartKey && chartValue !== undefined && chartValue !== null) {
                const isWithinRange = chartValue >= minPercent && chartValue <= maxPercent;
                console.log(`Checking ${chartKey}: User value ${chartValueRaw} (ceiled: ${chartValue}) against range ${minPercent}-${maxPercent}`);
                if (isWithinRange) {
                  specificityScore += 8;
                  console.log(`✅ PercentBracket match: ${chartKey} value ${chartValue} is within range (${minPercent}, ${maxPercent}]`);
                } else {
                  console.log(`❌ PercentBracket mismatch: ${chartKey} value ${chartValue} is NOT within range (${minPercent}, ${maxPercent}]`);
                  isValidMatch = false;
                }
              } else {
                console.log(`❌ No valid chart value found for ${chartKey}`);
                isValidMatch = false;
              }
            } else {
              console.log(`⚪ PercentBracket: Not specified in mapping`);
            }
            
            // FINAL EVALUATION: Only consider this mapping if it's still valid
            console.log(`Final evaluation - ID ${mapping.QuestionID}: Valid=${isValidMatch}, Score=${specificityScore}`);
            
            if (isValidMatch && specificityScore > bestSpecificityScore) {
              bestMatch = mapping;
              bestSpecificityScore = specificityScore;
              console.log(`🎯 NEW BEST MATCH: ID ${mapping.QuestionID} with score ${specificityScore}`);
            } else if (!isValidMatch) {
              console.log(`❌ REJECTED: ID ${mapping.QuestionID} - failed validation`);
            } else {
              console.log(`⚪ LOWER SCORE: ID ${mapping.QuestionID} - score ${specificityScore} vs current best ${bestSpecificityScore}`);
            }
          }
          
          // STEP 3: Use the best match if found
          if (bestMatch) {
            console.log(`🏆 Final best match: ID ${bestMatch.QuestionID} with score ${bestSpecificityScore}`);
            console.log(`Using mapping: ${bestMatch.QuestionText}`);
            
            // NEW: Check if the best match score is 0 - this means keyword matched but no valid attributes
            if (bestSpecificityScore === 0) {
              console.log("❌ Best match has 0 score - keyword found but no matching attributes");
              
              // Show sorry message for keyword with no valid configuration
              setMessages((prev) => [
                ...prev,
                { sender: "user", text: userQuery },
                { 
                  sender: "bot", 
                  text: `Sorry, I don't have specific information about "${userQuery}" for your natal configuration. Here are some topics you might be interested in:` 
                }
              ]);
              
              setIsFinal(false);
              setLoading(false);
              setInput("");
              return;
            }
            
            // Original logic for matches with score > 0
            // Add user message and show the answer directly
            setMessages((prev) => [
              ...prev,
              { sender: "user", text: userQuery },
              { sender: "bot", text: bestMatch.AnswerText }
            ]);
            
            // Handle selections if any - BUT only if it's NOT final
            if (bestMatch.Selection && bestMatch.IsFinal !== 1) {
              const selections = bestMatch.Selection.split(',').map((s, index) => {
                if (s.includes("|")) {
                  const [id, text] = s.split("|");
                  return { id: id.trim(), text: text.trim() };
                } else {
                  return { id: index, text: s.trim() };
                }
              });
              
              setQuestions(selections);
              setHideInitialQuestions(false);
            } else {
              setQuestions([]);
              setHideInitialQuestions(true);
            }
            
            setIsFinal(bestMatch.IsFinal === 1);
            setLoading(false);
            setInput("");
            return;
          } else {
            console.log("❌ No valid matches found after validation");
            
            // NEW: Handle the case where keyword exists but no matching natal/attributes
            // Check if any mapping had the keyword but failed validation
            let hadKeywordButFailedValidation = false;
            
            for (const mapping of potentialMatches) {
              console.log(`Checking failed validation for mapping ${mapping.QuestionID}`);
              
              // Check if this mapping failed due to natal/symbol validation
              let requiresNatalElementValidation = false;
              let natalRequirements = [];
              
              if (mapping.Natal && mapping.Natal.trim() !== "") {
                natalRequirements = mapping.Natal.split(',').map(n => n.trim());
                const a1b4Fields = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'];
                requiresNatalElementValidation = natalRequirements.some(req => a1b4Fields.includes(req));
              }
              
              if (requiresNatalElementValidation) {
                // Check if this failed due to natal element mismatch
                let failedNatalValidation = false;
                
                if (mapping.Symbol && mapping.Symbol.trim() !== "") {
                  const symbolParts = mapping.Symbol.split('.');
                  
                  for (let i = 0; i < natalRequirements.length; i++) {
                    const requirement = natalRequirements[i];
                    const symbolValue = symbolParts[i];
                    
                    let userValue = null;
                    switch (requirement) {
                      case 'A1': userValue = lunarData?.A1; break;
                      case 'A2': userValue = lunarData?.A2; break;
                      case 'A3': userValue = lunarData?.A3; break;
                      case 'A4': userValue = lunarData?.A4; break;
                      case 'B1': userValue = lunarData?.B1; break;
                      case 'B2': userValue = lunarData?.B2; break;
                      case 'B3': userValue = lunarData?.B3; break;
                      case 'B4': userValue = lunarData?.B4; break;
                    }
                    
                    const cleanUserValue = userValue ? userValue.toString().trim().replace(/\s+/g, '') : '';
                    const cleanSymbolValue = symbolValue ? symbolValue.toString().trim().replace(/\s+/g, '') : '';
                    
                    if (cleanUserValue && cleanSymbolValue) {
                      const valueMatch = cleanUserValue === cleanSymbolValue ||
                                      cleanUserValue.includes(cleanSymbolValue) ||
                                      cleanSymbolValue.includes(cleanUserValue) ||
                                      cleanUserValue.toLowerCase() === cleanSymbolValue.toLowerCase();
                      
                      if (!valueMatch) {
                        failedNatalValidation = true;
                        console.log(`Mapping ${mapping.QuestionID} failed natal validation: ${requirement} "${cleanUserValue}" ≠ "${cleanSymbolValue}"`);
                        break;
                      }
                    }
                  }
                }
                
                if (failedNatalValidation) {
                  hadKeywordButFailedValidation = true;
                  console.log(`Found keyword match but failed natal validation for mapping ${mapping.QuestionID}`);
                  break;
                }
              }
              
              // Also check for zodiac validation failures
              if (mapping.Natal && userZodiac && userZodiac.sign) {
                const mappingNatal = mapping.Natal.toLowerCase();
                const userZodiacLower = userZodiac.sign.toLowerCase();
                
                if (mappingNatal !== userZodiacLower && !requiresNatalElementValidation) {
                  hadKeywordButFailedValidation = true;
                  console.log(`Found keyword match but failed zodiac validation for mapping ${mapping.QuestionID}`);
                  break;
                }
              }
            }
            
            if (hadKeywordButFailedValidation) {
              console.log("Keyword found but no matching configuration for user's attributes");
              
              // Show sorry message for this specific case
              setMessages((prev) => [
                ...prev,
                { sender: "user", text: userQuery },
                { 
                  sender: "bot", 
                  text: `Sorry, I don't have specific information about "${userQuery}" for your natal configuration. Here are some topics you might be interested in:` 
                }
              ]);

              setIsFinal(false);
              setLoading(false);
              setInput("");
              return;
            }
          }
        }
        
        console.log("No keyword match found - proceeding with normal flow");
        
      } catch (error) {
        console.error("Error in keyword matching:", error);
      }
    }

    if (questionId) {
      try {
        if ((questionId === 1 || questionId === 2 || questionId === 3 || questionId === 4) && 
            (userQuery.toLowerCase().includes("find out more about myself male") || 
            userQuery.toLowerCase().includes("find out more about myself female") || 
            userQuery.toLowerCase().includes("natal zodiac pillar readings") || 
            userQuery.toLowerCase().includes("find out about my natal"))) {
          console.log(`Resetting questionId from ${questionId} to null for query: ${userQuery}`);
          questionId = null;  // Use null to omit the questionId parameter
        }
        // Use the question ID from button click or keyword mapping
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = `&questionid=${questionId}`;
        
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );
        
        const data = await response.json();
        console.log(`API response for query "${userQuery}" with ID ${questionId}:`, data);
        
        // Process the response as usual
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer }
        ]);
        
        // Handle selections
        if (data.selection) {
          const cleanedSelection = data.selection.replace(/\n/g, '');
          const selections = cleanedSelection.split(',')
            .filter(s => s.trim()) // Filter out empty entries
            .map((s) => {
              if (s.includes("|")) {
                const [id, text] = s.split("|");
                return { id: id.trim(), text: text.trim() };
              } else {
                return { id: s, text: s.trim() };
              }
            });

          console.log("Processing selection with length:", selections.length);
          console.log("API returned selections:", data.selection.replace(/\n/g, '').split(',').filter(s => s.trim()).length);
          console.log("Setting questions:", selections.length > 0 ? "YES" : "NO");
          console.log("Hiding buttons:", hideInitialQuestions);

          // Clear questions first and ensure buttons are hidden
          setHideInitialQuestions(true);
          setQuestions([]);
          

          // Then use a single setTimeout with enough delay
          setTimeout(() => {
            // Set new questions
            setQuestions(selections);
            
            // Only if we have questions to show, set hideInitialQuestions to false
            if (selections && selections.length > 0) {
              console.log("Setting buttons visible for", selections.length, "selections");
              setHideInitialQuestions(false);
            }
          }, 100);
        }
        
        setIsFinal(data.isfinal === 1);
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        console.error(`Error processing query with ID ${questionId}:`, error);
        setLoading(false);
        setInput("");
        return;
      }
    }
    
    if (questionId !== null) {
      try {
        // This is a selection from an API response with a proper questionId
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = `&questionid=${questionId}`;
        
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );
        
        const data = await response.json();
        console.log(`Selection API response for ${userQuery}:`, data);
        
        // Add user's message and bot response to the conversation
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer || `Information about ${userQuery}` }
        ]);
        
        // Handle any follow-up selections
        if (data.selection) {
          const cleanedSelection = data.selection.replace(/\n/g, '');
          const selections = cleanedSelection.split(',').map((s) => {
            if (s.includes("|")) {
              const [id, text] = s.split("|");
              return { id: id.trim(), text: text.trim() };
            } else {
              return { id: s, text: s.trim() };
            }
          });
          
          setQuestions(selections);
          setHideInitialQuestions(false);
        } else {
          setQuestions([]);
          setHideInitialQuestions(true);
        }
        
        setIsFinal(data.isfinal === 1);
        setLoading(false);
        setInput("");
        return;
      } catch (error) {
        console.error(`Error processing API selection ${userQuery}:`, error);
        setLoading(false);
        setInput("");
        return;
      }
    }

    // IMPORTANT: Reset the chart display whenever a new query is made
    // unless it's specifically a category selection
    if (!Object.keys(categoryMap).includes(userQuery.toLowerCase())) {
      setShowChart(false);
      setLocalChartData(null);
    }

    // Only clear charts if it's a reset/restart
    if (userQuery === "-1") {
      try {
        // Preserve current identity data
        const currentGender = userGender;
        const currentNatal = lunarData?.A2;
        const currentChartStrength = chartStrengthData?.category;
        console.log("Gender:", currentGender);
        console.log("Natal:", currentNatal);
        console.log("Chart Strength:", chartStrengthData?.category);
        await ensureCriticalData();

        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = questionId !== null ? `&questionid=${questionId}` : "";

        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );

        const data = await response.json();
        
        // IMPORTANT: Get the actual user DOB from the user profile FIRST
        const userData = await fetchUserData();
        const actualBirthDate = userData?.DOB ? new Date(userData.DOB) : new Date(apiDate);
        
        const year = actualBirthDate.getFullYear();
        const month = (actualBirthDate.getMonth() + 1).toString().padStart(2, "0");
        const day = actualBirthDate.getDate().toString().padStart(2, "0");
        const hour = actualBirthDate.getHours();
        const minutes = actualBirthDate.getMinutes();

        // Format time as HH:MM
        const timeString = `${hour.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

        console.log(`Using ACTUAL birth date for zodiac data: ${year}-${month}-${day} ${timeString}`);

        // Fetch lunar data using the CORRECT birth date and NEW API endpoint
        const lunarResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/member/GetChineseDOB?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${timeString}`
        );

        const zodiacData = await lunarResponse.json();
        let lunarInsightsHtml = "";

        if (zodiacData && zodiacData.length > 0) {
          const zodiacInfo = zodiacData[0];
          const zodiacSign = zodiacInfo.ZODIAC;
          const zodiacChinese = zodiacInfo.ZODIAC_CN;
          
          // IMPORTANT: Use the FRESH natal element from the API response A2 field
          let natalElement = zodiacInfo.A2;

          // Make sure we display something even if natalElement is null
          const displayNatalElement = natalElement || "Unknown";
          console.log("Final natal element to display:", displayNatalElement);
          
          // Important: Update the state with the NEW user's data
          setUserZodiac({
            sign: zodiacSign,
            chineseSign: zodiacChinese,
            natal: natalElement
          });
          
          // Update lunarData state with the new natal element
          setLunarData(prev => ({ 
            ...prev, 
            A2: natalElement 
          }));
          
          // Store in localStorage for persistence
          if (natalElement) {
            localStorage.setItem("userNatalElement", natalElement);
          }

          // Now create the lunar insights HTML with the FRESH data
          // lunarInsightsHtml = `
          //   <div style="margin-bottom: 15px;">
          //     <div style="font-weight: bold; font-size: 1.1rem;">Lunar Insights</div>
          //     <div style="margin: 5px 0;">${displayNatalElement}</div>
          //     <div style="">${zodiacSign} (${zodiacChinese})</div>
          //   </div>
          // `;
        }

        // Combine the API response with lunar insights
        const categoryKey = categoryOverride || currentCategory || "wealth";
        const percentValue = userChartValues[categoryKey.toUpperCase()];

        let percentageText = "";
        const displayCategory =
        categoryKey.toUpperCase() === "RS"
          ? "Relationship"
          : categoryKey.charAt(0).toUpperCase() + categoryKey.slice(1);

        // if (percentValue !== undefined && percentValue !== null) {
        //   percentageText = `<div style="margin-bottom: 8px; font-weight: bold; color: #DFBD69;">
        //     Your ${displayCategory} Score: ${percentValue}%
        //   </div>`;
        // }

        let suggestionList = [];
        switch (categoryKey.toLowerCase()) {
          case "wealth":
            suggestionList = [
              "How to improve my wealth",
              "What colour is lucky for me?"
            ];
            break;
          case "health":
            suggestionList = [
              "how to improve my health",
              "how to improve my mental health"
            ];
            break;
          case "career":
            suggestionList = [
              "What career should I do",
              "what venture"
            ];
            break;
          case "rs":
          case "relationship":
            suggestionList = [
              "How is my relationship?",
              "Am I suitable to marry?",
              "Should I stay single"
            ];
            break;
          case "wisdom":
            suggestionList = [
              "how to improve my intellectual",
              "how to improve my spiritual wisdom"
            ];
            break;
        }

        // const suggestionText = `
        //   <div style="margin-top: 10px; color: #DFBD69;">
        //     Try asking:
        //     <ul style="margin: 8px 0 0 18px; padding: 0;">
        //       ${suggestionList.map(s => `<li style="margin-bottom: 2px;"><b>${s}</b></li>`).join("")}
        //     </ul>
        //   </div>
        // `;

        const answerText = data.answer && data.answer.trim() ? data.answer : "No answer available for this topic.";

        const enhancedAnswer = [
          //percentageText,
          answerText,
          //suggestionText
        ].filter(Boolean).join("").trim();

        setMessages([
          { sender: "user", text: "Hello!" },
          { sender: "bot", text: enhancedAnswer },
        ]);

        // These lines ensure buttons don't appear initially:
        setHideInitialQuestions(true); // Changed from false to true
        setQuestions([]); // Empty the questions to ensure no buttons are shown

        // Only restore old data if the new fetch failed and we don't have fresh data
        if (!zodiacData || zodiacData.length === 0) {
          console.log("Failed to fetch new user data, keeping previous data");
          if (!userGender || !lunarData?.A2 || !chartStrengthData?.category) {
            console.log("Restoring identity data after failed -1 query");
            setUserGender(currentGender);
            setLunarData(prev => ({
              ...prev,
              A2: currentNatal
            }));
            setChartStrengthData(currentChartStrength);
          }
        }
        
        setHideInitialQuestions(false);
        setQuestions([]);
        setIsFinal(data.isfinal === 1);
      } catch (error) {
        console.error("Error fetching initial response:", error);
        setMessages([
          { sender: "user", text: "Hello!" },
          {
            sender: "bot",
            text: "Sorry, but we didn't find what your looking for. Here, select any topic that might interest you",
          },
        ]);

        setQuestions([]);
        setHideInitialQuestions(false);
      }

      setLoading(false);
      setInput("");
      return;
    }

    // Check if this is a category button click
    const normalizedCategory = userQuery.trim().toLowerCase();

    // if (categoryMap.hasOwnProperty(normalizedCategory)) {
    //   const categoryMatchesSelected =
    //     normalizedCategory === selectedChart?.toLowerCase() ||
    //     (selectedChart?.toLowerCase() === "rs" && normalizedCategory === "relationship");

    //   if (!categoryMatchesSelected) {
    //     const selectedDisplayName =
    //       selectedChart?.toUpperCase() === "RS"
    //         ? "Relationship"
    //         : selectedChart
    //         ? selectedChart.charAt(0).toUpperCase() + selectedChart.slice(1).toLowerCase()
    //         : "the selected topic";

    //     setMessages((prev) => [
    //       ...prev,
    //       { sender: "user", text: userQuery },
    //       {
    //         sender: "bot",
    //         text: `This chat is focused on ${selectedDisplayName}. Please ask questions related to ${selectedDisplayName}.`,
    //       },
    //     ]);
    //     setLoading(false);
    //     setInput("");
    //     return;
    //   }
    //   // Use chartData from props (from NataChart2) instead of fetching API
    //   // const mapping = categoryMap[normalizedCategory];
    //   // const value = chartData && mapping ? (chartData[mapping.apiKey] ?? 0) : 0;

    //   // setHideCategoryButtons(true);

    //   // setLocalChartData({
    //   //   category: mapping.apiKey,
    //   //   label: mapping.displayName.split(" ")[0],
    //   //   value: value,
    //   // });
    //   // setChartTitle(mapping.displayName);
    //   // setShowChart(true);
    //   // setShowHelpButton(true);
    //   // setCurrentCategory(normalizedCategory);

    //   // setMessages((prev) => [
    //   //   ...prev,
    //   //   { sender: "user", text: userQuery },
    //   //   {
    //   //     sender: "bot",
    //   //     text: `Your ${mapping.displayName} is ${value}/100`,
    //   //   },
    //   // ]);

    //   setLoading(false);
    //   setInput("");
    //   return;
    // }

    try {
      // Add a special flag to indicate this is a fallback case
      const isUnrecognizedQuery = !questionId && normalizedQuery !== "-1";
      
      // For unrecognized queries, show sorry message and use -1 selection buttons
      // if (isUnrecognizedQuery) {
      //   console.log("Unknown query detected, fetching -1 options for fallback");
        
      //   // Add user message first
      //   setMessages((prev) => [
      //     ...prev,
      //     { sender: "user", text: userQuery }
      //   ]);

      //   // Add sorry message
      //   setMessages((prev) => [
      //     ...prev,
      //     { 
      //       sender: "bot", 
      //       text: "Sorry, but we didn't find what you're looking for. Here, select any topic that might interest you."
      //     }
      //   ]);

      //   setLoading(false);
      //   setInput("");
      //   return; // Return early to prevent making another API call
      // } 
      if (isUnrecognizedQuery) {
        const selectedDisplayName =
          selectedChart?.toUpperCase() === "RS"
            ? "Relationship"
            : selectedChart
            ? selectedChart.charAt(0).toUpperCase() + selectedChart.slice(1).toLowerCase()
            : "the selected topic";

        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          {
            sender: "bot",
            text: `This chat is focused on ${selectedDisplayName}. Please ask questions related to ${selectedDisplayName}.`,
          },
        ]);
        setLoading(false);
        setInput("");
        return;
      } else {
        // For recognized queries, make the normal API call
        const queryParam = `userQuery=${encodeURIComponent(userQuery)}`;
        const idParam = questionId !== null ? `&questionid=${questionId}` : "";
        
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?${queryParam}${idParam}`
        );
        
        const data = await response.json();
        console.log(`API response for query "${userQuery}":`, data);
        
        // Add user message and bot response
        setMessages((prev) => [
          ...prev,
          { sender: "user", text: userQuery },
          { sender: "bot", text: data.answer }
        ]);
        
        // Process selections from API response
        const selections = data.selection
          ? data.selection.split(",")
            .filter(s => s.trim())
            .map((s, index) => {
              if (s.includes("|")) {
                const [id, text] = s.split("|");
                return { id, text: text.trim() };
              } else {
                return { id: index, text: s.trim() };
              }
            })
          : [];
        
        setQuestions(selections);
        setHideInitialQuestions(selections.length === 0);
        setIsFinal(data.isfinal === 1);
      }
    } catch (error) {
      console.error("Error fetching response:", error);
      
      // On error, show sorry message and try to get -1 options
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: userQuery },
        { 
          sender: "bot", 
          text: "Sorry, but we didn't find what you're looking for. Here, select any topic that might interest you."
        }
      ]);
      
      // Try to fetch -1 options as fallback for error case too
      try {
        const errorFallbackResponse = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/FairyChat/GetAnswer?userQuery=${encodeURIComponent("-1")}`
        );
        
        const errorFallbackData = await errorFallbackResponse.json();
        
        if (errorFallbackData.selection) {
          const cleanedSelection = errorFallbackData.selection.replace(/\n/g, '');
          const errorFallbackOptions = cleanedSelection.split(',')
            .filter(s => s.trim())
            .map((s) => {
              if (s.includes("|")) {
                const [id, text] = s.split("|");
                return { id: id.trim(), text: text.trim() };
              } else {
                return { id: s, text: s.trim() };
              }
            });
          
          setQuestions(errorFallbackOptions);
        } else {
          throw new Error("No selections in -1 response");
        }
      } catch (fallbackError) {
        console.error("Error fetching -1 fallback:", fallbackError);
        
        // Final hardcoded fallback
        setQuestions([
          { id: "402", text: "This year zodiac reading" },
          { id: "629", text: "Find out more about myself male" },
          { id: "630", text: "Find out more about myself female" },
          { id: "643", text: "Natal zodiac pillar readings" },
          { id: "709", text: "Find out about my natal" }
        ]);
      }
      
      setHideInitialQuestions(false);
    }

    setLoading(false);
    setInput("");
  };


  // Modify your return statement to better handle button display logic

  return (
    <div style={{
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "none",
      borderRadius: 0,
      overflow: "hidden",
      flex: 1
    }}>
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <div style={styles.messageContainer}>
          {/* Messages display */}
          {messages.map((msg, index) => (
            <div
              key={index}
              style={{
                ...styles.messageBox,
                backgroundColor: msg.sender === "user" ? "#DFBD69" : "#232224",
                color: msg.sender === "user" ? "#232224" : "#DFBD69",
                alignSelf: msg.sender === "user" ? "flex-end" : "flex-start",
                textAlign: msg.sender === "user" ? "right" : "left",
                marginLeft: msg.sender === "user" ? "auto" : undefined,
                marginRight: msg.sender === "user" ? "0" : undefined,
                maxWidth: "80%",
                width: "fit-content",
                minWidth: "40px",    
                wordBreak: "break-word", 
                whiteSpace: "pre-line", 
                padding: "10px 16px",   
              }}
            >
              {typeof msg.text === "string" ? (
                msg.text.includes("<div") ? (
                  <div dangerouslySetInnerHTML={{ __html: msg.text }} />
                ) : (
                  msg.text
                )
              ) : (
                msg.text
              )}
            </div>
          ))}
          
          {/* Loading animation */}
          {loading && <LoadingAnimation />}
          
          <div ref={messagesEndRef} />
        </div>

        {/* Input container */}
        <div style={{...styles.inputContainer}}>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your message..."
            style={styles.input}
            onKeyPress={(e) => e.key === "Enter" && fetchResponse(input)}
          />
          <button onClick={() => fetchResponse(input)} style={styles.button}>
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default TipsChatbot;
